import { render, staticRenderFns } from "./VacunaClasificacionNino.vue?vue&type=template&id=1a5bb6fc&scoped=true"
import script from "./VacunaClasificacionNino.vue?vue&type=script&lang=js"
export * from "./VacunaClasificacionNino.vue?vue&type=script&lang=js"
import style0 from "./VacunaClasificacionNino.vue?vue&type=style&index=0&id=1a5bb6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bb6fc",
  null
  
)

export default component.exports